const footfallEventTypes = {
  CLICKED: 'clicked',
  CLICKED_DISCOVER_SERVICE: 'clicked-discover-service',
  CLICKED_EXPLORE_TAB: 'clicked-explore-tab',
  CLICKED_FEATURED_POST: 'clicked-featured-post',
  CLICKED_LOST_ACCESS_CODE: 'clicked-lost-access-code',
  CLICKED_NEWSFEED_ITEM: 'clicked-newsfeed-item', // not used, only in BG
  CLICKED_NEXT_POST: 'clicked-next-post',
  CLICKED_RELATED_POST: 'clicked-related-post',
  CLICKED_RETENTION_FEED_ITEM: 'clicked-retention-feed-item', // not used, only in BG
  CLICKED_SEARCH_RESULT: 'clicked-search-result',
  DISMISSED_FEATURED_POST: 'dismissed-featured-post',
  FOLLOWED_USER: 'followed-user', // not used, only in BG
  NEEDS_ASSESSMENT: 'needs-assessment',
  PROFILE_SURVEY: 'profile-survey',
  SAW_OOPS_PAGE: 'saw-oops-page',
  SEARCHED_COMMUNITY: 'searched-community',
  SEARCHED_SITE: 'searched-site',
  SIGNED_UP: 'signed-up',
  SKIPPED_FEATURED_POST: 'skipped-featured-post',
  VIEWED_COMMUNITY: 'viewed-community',
  VIEWED_FEATURED_POST_UNIQUE: 'viewed-featured-post-unique',
  VIEWED_FEATURED_POST: 'viewed-featured-post',
  VIEWED_NEWSFEED: 'viewed-newsfeed', // not used, only in BG
  VIEWED_PAGE: 'viewed-page',
  VIEWED_POST: 'viewed-post',
  VIEWED_RETENTION_FEED: 'viewed-retention-feed', // not used, only in BG
  VIEWED_TAG_PAGE: 'viewed-tag-page',
  VIEWED_USER: 'viewed-user', // not used, only in BG
} as const;

export default footfallEventTypes;

// use the values of footfallEventTypes as the TS type
export type FootfallEventType = typeof footfallEventTypes[keyof typeof footfallEventTypes];
